import * as types from './types'
import storage from '@/Plugins/storage'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.RESET_HABIT](state, data) {
    state.habit = JSON.parse(JSON.stringify(state.defaultHabit))
    state.habit.orgId = data.orgId
  },
  [types.SET_HABIT_DATA](state, data) {
    switch (data.name) {
      case 'name': {
        state.habit.name = data.value
        break
      }
      case 'type': {
        state.habit.type = data.value
        break
      }
      case 'orgId': {
        state.habit.orgId = data.value
        break
      }
      case 'allowTime': {
        state.habit.allowTime = data.value
        break
      }
      case 'text': {
        state.habit.text = data.value
        break
      }
    }
  },
  [types.RESET_NUTRITION](state, data) {
    state.nutrition = JSON.parse(JSON.stringify(state.defaultNutrition))
    state.nutrition.user_id = data.userid
    state.nutrition.organization_id = data.orgid
  },
  [types.SET_NUTRITION](state, data) {
    state.nutrition = null
    if (data !== undefined && data !== null) {
      state.nutrition = data
    }
    console.log('Got Nutrition', state.nutrition)
  },
  [types.SET_MEALPLANS](state, data) {
    state.mealplans = null
    if (data !== undefined && data !== null) {
      state.mealplans = data
    }
    console.log('Got Meal Plans', state.mealplans)
  },
  [types.SET_HABIT_ICONS](state, data) {
    state.habitIcons = []
    if (data !== undefined && data !== null) {
      state.habitIcons = data.data
    }
    console.log('Got  Habit Icons', state.habitIcons)
  },
  [types.SET_NUTRITION_HABIT](state, id) {
    state.habit = null
    state.habit = state.habits.find((x) => parseInt(x.id) === parseInt(id))
    console.log('Got Nutrition Habit', state.habit)
  },
  [types.SET_NUTRITION_HABITS](state, data) {
    state.habits = []
    if (data !== undefined && data !== null) {
      state.habits = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Nutrition Habits', state.habits)
  },
}
